import { defaultReplacer, applyReplacerDeep } from './buffer.js';
import { 
  MAGIC, VERSION, 
  writeUint32, writeUint16, writeUint8,
  encodeObject,
  calculateChecksum, base64urlEncode
} from './binary.js';

// ---------- Binary Capsule Format ----------
// [ 0..3 ]  Magic "JSC2" (Jucie State Capsule v2)
// [ 4..5 ]  u16 version (big-endian) = 2
// [ 6 ]     u8 flags (reserved for future use)
// [ 7..10 ] u32 checksum (simple checksum)
// [11..14 ] u32 payloadLength (big-endian)
// [15.. ]   payload bytes (binary encoded data)

// ---------- Public API ----------

/**
 * Export any data object as a resilient binary capsule string (base64url).
 * Reciprocal with importState.
 * @param {Object} data - The data object to export
 * @param {Object} options - Export options
 */
export async function pack(data, { replacer = defaultReplacer } = {}) {
  // 1) Clean ephemeral/transient fields
  const clean = applyReplacerDeep(data, replacer);

  // 2) Encode data to binary
  const dataBuffer = encodeObject(clean);

  // 3) Create payload: [dataLength:4][data:varies]
  const payloadLength = 4 + dataBuffer.length;
  const payload = new Uint8Array(payloadLength);
  
  let offset = 0;
  offset = writeUint32(dataBuffer.length, payload, offset);
  payload.set(dataBuffer, offset);

  // 4) Calculate checksum
  const checksum = calculateChecksum(payload);

  // 5) Build capsule
  const headerLen = 4 + 2 + 1 + 4 + 4; // 15 bytes
  const capsule = new Uint8Array(headerLen + payload.length);

  // Magic
  capsule.set(MAGIC, 0);

  // Version u16 LE
  writeUint16(VERSION, capsule, 4);

  // Flags u8
  writeUint8(0, capsule, 6);

  // Checksum u32 LE
  writeUint32(checksum, capsule, 7);

  // Payload length u32 LE
  writeUint32(payload.length, capsule, 11);

  // Payload
  capsule.set(payload, 15);

  // 6) Base64url encode (single portable string)
  return base64urlEncode(capsule);
}